export default function cssVar(name, value) {
  const variableName = `--${name}`;
  if (value) document.documentElement.style.setProperty(variableName, value);
  return getComputedStyle(document.documentElement).getPropertyValue(variableName);
}
